import React, { useState } from "react";
import BasicGrid from "./Grid";
import { FilterMode } from "./Filter";
import { Button, Col, Row, Tabs } from "antd";
import {
  FormOutlined,
  ReloadOutlined,
  SaveOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { FormSection } from "./Form";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";
import {
  deleteNearToExpiryDiscountApi,
  putNearToExpiryDiscountApi,
} from "../../../services/nearToExpiry";
const NearToExpiryItem = () => {
  const [activeTab, setActiveTab] = useState("grid");
  const [editData, setEditData] = useState(null);
  const [formPayload, setFormPayload] = useState(null);
  const [resetKey, setResetKey] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const { addExpiryDiscount } = useNearToExpiryStore();
  const handleSubmit = async () => {
    const newErrors = {};
    if (!formPayload?.division) newErrors.division = "Division is required";
    if (!formPayload?.department)
      newErrors.department = "Department is required";
    if (formPayload?.expiryDiscount == null)
      newErrors.expiryDiscount = "Expiry Discount is required";
    if (formPayload?.nearExpiryDiscount == null)
      newErrors.nearExpiryDiscount = "Near Expiry Discount is required";

    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
      return;
    }
    const apiPayload = {
      divisionCode: Number(formPayload.division),
      departmentCode: Number(formPayload.department),
      discount1: formPayload.expiryDiscount,
      discount2: formPayload.nearExpiryDiscount,
      isActive: true,
    };
    if (editData?.Id) {
      await putNearToExpiryDiscountApi(editData?.Id, apiPayload);
    } else {
      await addExpiryDiscount(apiPayload);
    }
    setActiveTab("grid");
    setEditData(null);
    setFormPayload(null);
    setFormErrors({});
  };

  const handleReset = async () => {
    setResetKey((prev) => prev + 1);
    setFormPayload(null);
  };

  return (
    <>
      <Row style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
        <Col>
          <Tabs
            activeKey={activeTab}
            onChange={(key) => {
              setActiveTab(key);
              setEditData(null);
              setFormPayload(null);
              setFormErrors({});
            }}
            type="card"
            size="large"
            items={[
              {
                key: "grid",
                label: "View Records",
              },
              {
                key: "form",
                label: "Add/Edit Form",
              },
            ]}
          />
        </Col>
      </Row>
      {activeTab === "form" && (
        <Row
          justify="end"
          style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
        >
          <Col
            xl={{ size: 3, offset: 7 }}
            md={{ size: 8 }}
            sm={{ size: 12 }}
            xs={{ size: 20 }}
            style={{ textAlign: "center" }}
          >
            <Button
              type="primary"
              icon={<SaveOutlined />}
              size="large"
              style={{
                marginRight: "0.75rem",
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                boxShadow: "0 2px 6px rgba(82, 196, 26, 0.3)",
              }}
              onClick={handleSubmit}
            >
              {editData?.Id ? "Update" : "Submit"}
            </Button>

            <Button
              icon={<ReloadOutlined />}
              size="large"
              style={{
                borderColor: "#ff1818ff",
                color: "#ff1818ff",
              }}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </Row>
      )}
      {activeTab === "form" && (
        <FormSection
          editData={editData}
          errors={formErrors}
          onChange={setFormPayload}
          resetKey={resetKey}
          resetTrigger={!editData && !formPayload}
        />
      )}
      {activeTab === "grid" && (
        <>
          <FilterMode />
          <BasicGrid
            onEditRow={(row) => {
              setEditData(row);
              setActiveTab("form");
            }}
          />
        </>
      )}
    </>
  );
};

export default NearToExpiryItem;
